import { usePodcastStore } from '../store/usePodcastStore';
import { Enum_Podcastinteraction_Type } from '@/graphql/generated/graphql';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import ExpandableCard from './ExpandableCard';

export default function GetInvolved({
  showGetInTouch = true,
  showSuggestionBox = true,
}: {
  showGetInTouch?: boolean;
  showSuggestionBox?: boolean;
}) {
  const { page } = usePodcastStore();
  const { getInTouchSection, questionsSection } = page.page || {};

  return (
    <>
      <div className="col-span-12 mb-[14px] mt-sh-60 lg:col-start-11 lg:col-end-3">
        <></>
        <AnimatedFadeInComponent>
          <h1 className=" text-sh-md font-bold">Get involved</h1>
        </AnimatedFadeInComponent>
      </div>
      <div className="col-span-12 grid grid-cols-1 items-start gap-4 lg:col-start-11 lg:col-end-3 lg:grid-cols-2">
        {showGetInTouch && (
          <ExpandableCard getInTouchSection={getInTouchSection} type={Enum_Podcastinteraction_Type.Suggestion} />
        )}
        {showSuggestionBox && (
          <ExpandableCard getInTouchSection={questionsSection} type={Enum_Podcastinteraction_Type.Question} />
        )}
      </div>
    </>
  );
}
